export function createEntityIndex({ hostAdapter, toPositiveInt }) {
  const findLoadedEntities = (id, kind) => {
    const numericId = toPositiveInt(id);
    if (!numericId) {
      return [];
    }

    const {
      selecteds = [],
      currentElement = null,
      reactionElements: reactionList = [],
      sampleElements: sampleList = [],
    } = hostAdapter.readEntityPools();

    const entryPool = selecteds
      .concat([currentElement])
      .concat(reactionList)
      .concat(sampleList)
      .filter((entry) => entry && !Array.isArray(entry));

    const seenRefs = new WeakSet();
    const matches = [];

    entryPool.forEach((entry) => {
      if (!entry || entry.type !== kind) {
        return;
      }
      if (toPositiveInt(entry.id) !== numericId) {
        return;
      }
      if (seenRefs.has(entry)) {
        return;
      }
      seenRefs.add(entry);
      matches.push(entry);
    });

    return matches;
  };

  const findOpenEntity = (id, kind) => {
    const matches = findLoadedEntities(id, kind);
    return matches[0] || null;
  };

  return {
    findLoadedEntities,
    findOpenEntity,
  };
}
